import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=0a86b316"
import script from "./main-footer.vue?vue&type=script&lang=js"
export * from "./main-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports